import type { LegalContent } from "./types";

export const privacyZh: LegalContent = {
  seo: {
    title: "隐私政策 - Luxoria",
    description: "Luxoria 如何处理照片、视频、系统权限、临时文件与数据。"
  },
  tag: "法律",
  title: "隐私政策",
  lastUpdated: "最后更新：2026 年 6 月 8 日",
  sections: [
    {
      heading: "1. 概述",
      body: "本隐私政策说明在你使用 Luxoria 将 SDR 素材转换为适合 HDR 显示的输出时，应用如何处理你的照片、视频及相关信息。Luxoria 的转换在你的设备上完成。"
    },
    {
      heading: "2. 照片与视频",
      body: "Luxoria 仅处理你明确选择用于 HDR 转换的照片和视频。你的素材用于生成转换后的输出文件，不会用于任何无关用途。"
    },
    {
      heading: "3. 本地处理",
      body: "HDR 转换作为应用本地处理流程的一部分在你的设备上完成。Luxoria 致力于将转换流程保留在本地，而不是依赖外部处理服务，也不会将你的照片和视频上传到我们的服务器。"
    },
    {
      heading: "4. 临时文件",
      body: "在转换和导出过程中，Luxoria 可能会创建临时输出文件以支持保存与分享。这些临时文件仅作用于当前操作，并可能在使用后由应用清理。"
    },
    {
      heading: "5. 系统权限",
      body: "根据平台和所选流程，Luxoria 可能会请求访问你的照片库或你选择的文件。这些权限用于读取你选择的素材并保存转换结果。"
    },
    {
      heading: "6. 数据收集",
      body: "Luxoria 转换素材无需注册账户。应用专注于处理你选择的素材，而不是收集个人画像。你通过邮件主动发送的任何诊断信息仅用于提供支持。"
    },
    {
      heading: "7. 第三方服务",
      body: "核心 HDR 转换不依赖第三方内容服务。照片、文件或平台分享面板等系统功能受你的操作系统及其条款约束。"
    },
    {
      heading: "8. 儿童隐私",
      body: "Luxoria 是一款通用的媒体转换工具，并非面向儿童。我们不会有意收集儿童的个人信息。"
    },
    {
      heading: "9. 政策变更",
      body: "随着应用的发展，我们可能会更新本隐私政策。发生重大变更时，我们会更新上方显示的日期。继续使用 Luxoria 即表示接受更新后的政策。"
    },
    {
      heading: "10. 联系我们",
      body: "如对本隐私政策或 Luxoria 如何处理你的素材有疑问，请通过 axqora@gmail.com 联系我们。"
    }
  ],
  contact: {
    title: "关于隐私的疑问？",
    body: "请发送邮件至 axqora@gmail.com，我们会尽快回复。"
  }
};
